import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const Badge = ({ ok, okText, noText, testid }) => (
  <span
    className={`text-xs px-2.5 py-1 rounded-full ${ok ? "bg-emerald-500/10 text-emerald-400" : "bg-white/5 text-zinc-500"}`}
    data-testid={testid}
  >
    {ok ? okText : noText}
  </span>
);

export default function Customers() {
  const [customers, setCustomers] = useState(null);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data)).catch(() => setCustomers([]));
  }, []);

  return (
    <div data-testid="admin-customers-page">
      <h1 className="font-['Outfit'] font-extrabold tracking-tight text-3xl mb-2">Customers</h1>
      <p className="text-zinc-500 text-sm mb-8">People who shared their information — with payment and drive link status.</p>
      <div className="bg-[#0a0a0a] border border-white/10 rounded-2xl overflow-x-auto">
        <Table data-testid="customers-table" className="min-w-[720px]">
          <TableHeader>
            <TableRow className="border-white/10 hover:bg-transparent">
              <TableHead className="text-zinc-400">Name</TableHead>
              <TableHead className="text-zinc-400">Phone</TableHead>
              <TableHead className="text-zinc-400">Payment</TableHead>
              <TableHead className="text-zinc-400">Drive Link</TableHead>
              <TableHead className="text-zinc-400">Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {customers?.map((c) => (
              <TableRow key={c.lead_id} className="border-white/5 hover:bg-white/5" data-testid={`customer-row-${c.lead_id}`}>
                <TableCell className="text-white">{c.name}</TableCell>
                <TableCell className="text-zinc-400">{c.phone}</TableCell>
                <TableCell>
                  <Badge ok={c.paid} okText="Paid" noText="Not Paid" testid={`customer-paid-${c.lead_id}`} />
                </TableCell>
                <TableCell>
                  <Badge ok={c.link_opened} okText="Opened" noText="Not Opened" testid={`customer-opened-${c.lead_id}`} />
                </TableCell>
                <TableCell className="text-zinc-500 text-xs">{new Date(c.created_at).toLocaleString("en-IN")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {customers && customers.length === 0 && (
          <p className="text-zinc-500 text-sm p-8 text-center" data-testid="customers-empty">No customers yet.</p>
        )}
      </div>
    </div>
  );
}
